/**
 * Computes the backend's `afterTaskId` sentinel for inserting a task at
 * `insertBeforeIndex` within `tasks` (the target column/group's current,
 * fully-loaded task list, NOT including the task being moved/reordered).
 *
 * Matches the "drop on task at index i" = "insert before that task" convention
 * already used by Kanban's same-column reorder splice logic.
 *
 * @returns `null` to append at the end (insertBeforeIndex >= tasks.length), the
 *   `'0'` sentinel to insert at the very top (insertBeforeIndex <= 0), or the ID
 *   of the task immediately preceding the insertion point.
 */
export function computeAfterTaskId(
  tasks: { id: string }[],
  insertBeforeIndex: number,
): string | null {
  if (insertBeforeIndex <= 0) return '0';
  if (insertBeforeIndex >= tasks.length) return tasks[tasks.length - 1]?.id ?? null;
  return tasks[insertBeforeIndex - 1].id;
}
